import React, { createContext, useContext, useState } from "react";

interface DiscoverSessionContextType {
  sessionActive: boolean;
  setSessionActive: (active: boolean) => void;
}

const DiscoverSessionContext = createContext<DiscoverSessionContextType>({
  sessionActive: false,
  setSessionActive: () => {},
});

export const useDiscoverSession = () => useContext(DiscoverSessionContext);

export const DiscoverSessionProvider = ({ children }: { children: React.ReactNode }) => {
  const [sessionActive, setSessionActive] = useState(false);
  return (
    <DiscoverSessionContext.Provider value={{ sessionActive, setSessionActive }}>
      {children}
    </DiscoverSessionContext.Provider>
  );
};
